'use client';

import './styles/@theme';
import { useAccountUm } from '@/hooks/use-account-um';
import { getText } from '@/utils/text/text';

export const AuthenticationButtons: React.FC = () => {
    const { triggerLogin, triggerRegister } = useAccountUm();

    return (
        <div className="header-buttons-container">
            <button className="log-in" onClick={() => triggerLogin()}>
                {getText({ text: 'common.login' })}
            </button>
            <button className="join-now" onClick={() => triggerRegister()}>
                {getText({ text: 'common.joinNow' })}
            </button>
        </div>
    );
};
